module.exports = __webpack_public_path__ + "static/media/logoBAB2.8d0b1b8f.jpeg";